import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@utex/ui-kit';
import { Money, MoneyView } from '../MoneyView';
import { useResult } from './hooks';

interface Props {
  amount: Money;
}

export const Result: React.FC<Props> = ({ amount }) => {
  const { t } = useTranslation('conversion');
  const result = useResult(amount);
  if (!result) {
    return null;
  }

  return (
    <>
      <Typography.Text size="S" view="hint">
        {t('To be credited')}
      </Typography.Text>
      <Typography.Text size="S">
        ≈<MoneyView>{result}</MoneyView>
      </Typography.Text>
    </>
  );
};
